import { render, staticRenderFns } from "./CreateAccountLayout.vue?vue&type=template&id=04ed4e80&scoped=true&"
import script from "./CreateAccountLayout.vue?vue&type=script&lang=js&"
export * from "./CreateAccountLayout.vue?vue&type=script&lang=js&"
import style0 from "./CreateAccountLayout.vue?vue&type=style&index=0&id=04ed4e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ed4e80",
  null
  
)

export default component.exports